@let isMountTypeFormFieldShown = $isMountTypeFormFieldShown();
@let isOnboardVoltageFormFieldShown = $isOnboardVoltageFormFieldShown();
@let isCutoffSwitchFormFieldShown = $isCutoffSwitchFormFieldShown();
@let isDesktop = $isDesktop();

@if (!loading()) {
  <div
    [ngClass]="{
      'flex flex-col items-start px-2': !isDesktop,
    }"
  >
    <h1
      class="x-font-body-1-bold x-text-dark-main text-center"
      [ngClass]="{
        '-mt-3.5': isDesktop,
      }"
    >
      {{
        'request_form.devices.add_device.additional_settings_title' | translate
      }}
    </h1>
    <form [formGroup]="formGroup" class="w-full">
      @if (isDesktop) {
        @if (isMountTypeFormFieldShown) {
          <section class="mt-11">
            <h2 class="x-font-body-3-bold mb-3.5">
              {{ 'request_form.devices.add_device.mount_type' | translate }}
            </h2>
            <div class="flex flex-wrap gap-4">
              @for (mountOption of mountTypeOptions; track mountOption) {
                <label
                  tuiBlock="m"
                  appearance=""
                  class="justify-between w-[139px] h-[134px] device-additional-settings-block"
                >
                  @if (mountTypeFormField.value === mountOption) {
                    <tui-icon
                      size="l"
                      icon="@tui.check"
                      class="x-bg-green rounded-full text-white right-0 bottom-0 absolute size-6 text-base"
                    ></tui-icon>
                  }
                  <span
                    class="block text-wrap x-text-dark-main x-font-body-3 text-left"
                    >{{
                      getMountTypeTranslationKey(mountOption) | translate
                    }}</span
                  >
                  <input
                    tuiRadio
                    type="radio"
                    tuiBlock
                    [formControlName]="FormFields.MountType"
                    [value]="mountOption"
                    (click)="toggleMountType($event, mountOption)"
                  />
                </label>
              }
            </div>
          </section>
        }
        @if (isOnboardVoltageFormFieldShown) {
          <section
            [ngClass]="{
              'mt-11': !isMountTypeFormFieldShown,
              'mt-8.5': isMountTypeFormFieldShown,
            }"
          >
            <h2 class="x-font-body-2-bold mb-3.5">
              {{
                'request_form.devices.add_device.onboard_voltage' | translate
              }}
            </h2>
            <div class="flex flex-wrap gap-4">
              @for (
                voltageOption of onboardVoltageOptions;
                track voltageOption
              ) {
                <label
                  tuiBlock="m"
                  appearance=""
                  class="justify-between w-[139px] h-[134px] device-additional-settings-block"
                >
                  @if (onboardVoltageFormField.value === voltageOption) {
                    <tui-icon
                      size="l"
                      icon="@tui.check"
                      class="x-bg-green rounded-full text-white right-0 bottom-0 absolute size-6 text-base"
                    ></tui-icon>
                  }
                  <span
                    class="block text-wrap x-text-dark-main x-font-body-2 text-left"
                    >{{ voltageOption }}</span
                  >
                  <input
                    tuiRadio
                    type="radio"
                    tuiBlock
                    [formControlName]="FormFields.OnboardVoltage"
                    [value]="voltageOption"
                    (click)="toggleOnboardVoltage($event, voltageOption)"
                  />
                </label>
              }
            </div>
          </section>
        }
        @if (isCutoffSwitchFormFieldShown) {
          <section
            [ngClass]="{
              'mt-11': !isCutoffSwitchFormFieldShown,
              'mt-8.5': isCutoffSwitchFormFieldShown,
            }"
          >
            <h2 class="x-font-body-2-bold mb-3.5">
              {{ 'request_form.devices.add_device.cutoff_switch' | translate }}
            </h2>
            <div class="flex flex-wrap gap-4">
              @for (
                cutoffSwitchOption of cutoffSwitchOptions;
                track cutoffSwitchOption
              ) {
                <label
                  tuiBlock="m"
                  appearance=""
                  class="justify-between w-[139px] h-[134px] device-additional-settings-block"
                >
                  @if (cutoffSwitchFormField.value === cutoffSwitchOption) {
                    <tui-icon
                      size="l"
                      icon="@tui.check"
                      class="x-bg-green rounded-full text-white right-0 bottom-0 absolute size-6 text-base"
                    ></tui-icon>
                  }
                  <span
                    class="block text-wrap x-text-dark-main x-font-body-2 text-left"
                    >{{
                      getCutoffSwitchTranslationKey(cutoffSwitchOption)
                        | translate
                    }}</span
                  >
                  <input
                    tuiRadio
                    type="radio"
                    tuiBlock
                    [formControlName]="FormFields.CutoffSwitch"
                    [value]="cutoffSwitchOption"
                    (click)="toggleCutoffSwitch($event, cutoffSwitchOption)"
                  />
                </label>
              }
            </div>
          </section>
        }
        <div class="text-right">
          <button
            tuiButton
            appearance="primary"
            size="s"
            class="x-font-body-3-bold-important w-[144px] h-[32px] mt-8.5"
            type="button"
            [disabled]="formGroup.invalid"
            (click)="submit()"
          >
            {{
              'request_form.devices.add_device.additional_settings_modal_submit_button'
                | translate
            }}
          </button>
        </div>
      } @else {
        @if (isMountTypeFormFieldShown) {
          <section class="mt-6">
            <h2 class="x-font-body-2-bold mb-3.5 ms-1.5">
              {{ 'request_form.devices.add_device.mount_type' | translate }}
            </h2>
            <div class="flex flex-wrap gap-[15px] justify-evenly">
              @for (mountOption of mountTypeOptions; track mountOption) {
                <label
                  tuiBlock="m"
                  appearance=""
                  class="justify-between device-additional-settings-block flex-[1_1_calc(50%-15px)] max-w-[calc(50%-15px)] h-[80px] min-w-0"
                >
                  @if (mountTypeFormField.value === mountOption) {
                    <tui-icon
                      size="l"
                      icon="@tui.check"
                      class="x-bg-green rounded-full text-white right-0 bottom-0 absolute size-6 text-base"
                    ></tui-icon>
                  }
                  <span
                    class="block text-wrap x-text-dark-main x-font-body-2 text-left"
                    >{{
                      getMountTypeTranslationKey(mountOption) | translate
                    }}</span
                  >
                  <input
                    tuiRadio
                    type="radio"
                    tuiBlock
                    [formControlName]="FormFields.MountType"
                    [value]="mountOption"
                    (click)="toggleMountType($event, mountOption)"
                  />
                </label>
              }
            </div>
          </section>
        }
        @if (isOnboardVoltageFormFieldShown) {
          <section
            [ngClass]="{
              'mt-6': !isMountTypeFormFieldShown,
              'mt-4': isMountTypeFormFieldShown,
            }"
          >
            <h2 class="x-font-body-2-bold mb-3.5 ms-1.5">
              {{
                'request_form.devices.add_device.onboard_voltage' | translate
              }}
            </h2>
            <div class="flex flex-wrap gap-[15px] justify-evenly">
              @for (
                voltageOption of onboardVoltageOptions;
                track voltageOption
              ) {
                <label
                  tuiBlock="m"
                  appearance=""
                  class="justify-between device-additional-settings-block flex-[1_1_calc(50%-15px)] max-w-[calc(50%-15px)] h-[50px] min-w-0"
                >
                  @if (onboardVoltageFormField.value === voltageOption) {
                    <tui-icon
                      size="l"
                      icon="@tui.check"
                      class="x-bg-green rounded-full text-white right-0 bottom-[4px] absolute size-6 text-base"
                    ></tui-icon>
                  }
                  <span
                    class="block text-wrap x-text-dark-main x-font-body-2 text-left"
                    >{{ voltageOption }}</span
                  >
                  <input
                    tuiRadio
                    type="radio"
                    tuiBlock
                    [formControlName]="FormFields.OnboardVoltage"
                    [value]="voltageOption"
                    (click)="toggleOnboardVoltage($event, voltageOption)"
                  />
                </label>
              }
            </div>
          </section>
        }
        @if (isCutoffSwitchFormFieldShown) {
          <section
            [ngClass]="{
              'mt-6': !isCutoffSwitchFormFieldShown,
              'mt-4': isCutoffSwitchFormFieldShown,
            }"
          >
            <h2 class="x-font-body-2-bold mb-3.5 ms-1.5">
              {{ 'request_form.devices.add_device.cutoff_switch' | translate }}
            </h2>
            <div class="flex flex-wrap gap-[15px] justify-evenly">
              @for (
                cutoffSwitchOption of cutoffSwitchOptions;
                track cutoffSwitchOption
              ) {
                <label
                  tuiBlock="m"
                  appearance=""
                  class="justify-between device-additional-settings-block flex-[1_1_calc(50%_-_15px)] max-w-[calc(50%_-_15px)] h-[50px] min-w-0"
                >
                  @if (cutoffSwitchFormField.value === cutoffSwitchOption) {
                    <tui-icon
                      size="l"
                      icon="@tui.check"
                      class="x-bg-green rounded-full text-white right-0 bottom-[4px] absolute size-6 text-base"
                    ></tui-icon>
                  }
                  <span
                    class="block text-wrap x-text-dark-main x-font-body-2 text-left"
                    >{{
                      getCutoffSwitchTranslationKey(cutoffSwitchOption)
                        | translate
                    }}</span
                  >
                  <input
                    tuiRadio
                    type="radio"
                    tuiBlock
                    [formControlName]="FormFields.CutoffSwitch"
                    [value]="cutoffSwitchOption"
                    (click)="toggleCutoffSwitch($event, cutoffSwitchOption)"
                  />
                </label>
              }
            </div>
          </section>
        }
        <button
          tuiButton
          appearance="primary"
          size="m"
          [disabled]="formGroup.invalid"
          class="x-font-body-2-bold-important w-full mt-6 mb-4"
          type="button"
          (click)="submit()"
        >
          {{
            'request_form.devices.add_device.additional_settings_modal_submit_button'
              | translate
          }}
        </button>
      }
    </form>
  </div>
}
